import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/Button';
import { slickBreakpoints } from './Carousel';

export const Testimonial = ({
  mobileImgUrl,
  desktopImgUrl,
  quote,
  person,
  subtitle,
  linkUrl,
  linkDisplayText,
}) => {
  return (
    <div className="testimonial-card row">
      <div className="testimonial-card__overlay" />
      <picture>
        <source
          media={`(max-width: ${slickBreakpoints.mobile}px)`}
          srcSet={mobileImgUrl}
        />
        <img src={desktopImgUrl} />
      </picture>

      <div className="testimonial-card__content col-xs-9 col-sm-5 col-lg-5">
        <blockquote className="testimonial-card__quote">{quote}</blockquote>
        <cite className="testimonial-card__quote--identifier">{person}</cite>
        <p className="testimonial-card__quote--subtitle">{subtitle}</p>
        <Button
          element="a"
          className="testimonial-card__button button--outline button--inverted"
          href={linkUrl}
        >
          {linkDisplayText}
        </Button>
      </div>
    </div>
  );
};

Testimonial.propTypes = {
  quote: PropTypes.string.isRequired,
  person: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  mobileImgUrl: PropTypes.string.isRequired,
  desktopImgUrl: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  linkDisplayText: PropTypes.string.isRequired,
};
